import { NavLink, useLocation } from "react-router-dom";
import Image from "../Image";
import { Container, Nav, NavLeft, NavMenu, NavUser } from "./styles";
import MacroContainer from "../MacroContainer";
import Logo from "../../assets/images/logo_white.svg";
import DefaultImage from "../../assets/images/profile_business.jpg";
import { SideBar } from "../SideBar";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MobileDropdown } from "../MobileDropdown";
import { useScreenSize } from "../../hooks/useScreenSize";
import Business from "../../services/Business";
import { usePermissions } from "../../hooks";
import { useTheme } from "../../utils/theme";

export default () => {
  const { theme: customTheme } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [business, setBusiness] = useState({});
  const [psychosocialEnabled, setPsychosocialEnabled] = useState(false);
  const [t, i18n] = useTranslation('common');
  const { checkPermissions } = usePermissions();
  const { isMobile } = useScreenSize();
  const location = useLocation();
  const isActionPlanRoute = location.pathname.startsWith('/action-plan');
  const getData = async () => {
    const { data } = await Business.get();
    setBusiness(data);
    try {
      const metaRes = await Business.getPlanMetaByKey('psychosocial_mapping_enabled');
      setPsychosocialEnabled(!!metaRes?.values?.psychosocial_mapping_enabled);
    } catch {
      setPsychosocialEnabled(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <SideBar visible={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Container>
        <MacroContainer>
          <Nav>
            <NavLeft>
              {customTheme?.logo ? (
                <Image src={customTheme.logo} width={100} height={50} style={{ backgroundColor: '#fff', borderRadius: '14px', objectFit: 'contain', padding: '10px' }} />
              ) : (
                <Image src={Logo} width={50} height={50} />
              )}
              {isMobile ? (
                <MobileDropdown 
                  items={[
                    { text: t('home'), to: '/' },
                    ...(checkPermissions('menu:dashboard:single') ? [{ text: t('internal_dashboard'), to: '/dashboards' }] : []),
                    ...(checkPermissions('menu:dashboard:multi') ? [{ text: t('general_dashboard'), to: '/general-dashboard' }] : []),
                    ...(checkPermissions('menu:dashboard:vitalscanalerts') ? [{ text: t('vitalscan_alerts'), to: '/vitalscan-alerts' }] : []),
                    ...(checkPermissions('menu:users') ? [{ text: t('users'), to: '/users' }] : []),
                    ...(checkPermissions('menu:preregister') ? [{ text: t('pre-registration'), to: '/pre-registration' }] : []),
                    ...(checkPermissions('menu:gamification') ? [{ text: t('gamification'), to: '/leaderboard' }] : []),
                    ...(checkPermissions('menu:companiesmanagement') ? [{ text: t('businesses'), to: '/businesses' }] : []),
                    ...(checkPermissions('menu:eligibilitymanagement') ? [{ text: t('eligibility-management'), to: '/eligibility-management' }] : []),
                    ...(psychosocialEnabled && checkPermissions('menu:surveydashboard') ? [{ text: t('psciossocial-risk'), to: '/psciossocial-risk', activeMatch: ['/action-plan'] }] : []),
                    ...(checkPermissions('menu:fiscal') ? [{ text: t('fiscal'), to: '/fiscal' }] : [])
                  ]}
                  t={t}
                />
              ) : (
                <NavMenu>
                  <NavLink to="/">{t('home')}</NavLink>
                  {checkPermissions('menu:dashboard:single') && <NavLink to="/dashboards">{t('internal_dashboard')}</NavLink>}
                  {checkPermissions('menu:dashboard:multi') && <NavLink to="/general-dashboard">{t('general_dashboard')}</NavLink>}
                  {checkPermissions('menu:dashboard:vitalscanalerts') && <NavLink to="/vitalscan-alerts">{t('vitalscan_alerts')}</NavLink>}
                  {checkPermissions('menu:users') && <NavLink to="/users">{t('users')}</NavLink>}
                  {checkPermissions('menu:preregister') && <NavLink to="/pre-registration">{t('pre-registration')}</NavLink>}
                  {checkPermissions('menu:gamification') && <NavLink to="/leaderboard">{t('gamification')}</NavLink>}
                  {checkPermissions('menu:companiesmanagement') && <NavLink to="/businesses">{t('businesses')}</NavLink>}
                  {checkPermissions('menu:eligibilitymanagement') && <NavLink to="/eligibility-management">{t('eligibility-management')}</NavLink>}
                  {psychosocialEnabled && checkPermissions('menu:surveydashboard') && (
                    <NavLink
                      to="/psciossocial-risk"
                      className={({ isActive }) => (isActive || isActionPlanRoute ? 'active' : undefined)}
                    >
                      {t('psciossocial-risk')}
                    </NavLink>
                  )}
                  {checkPermissions('menu:fiscal') && <NavLink to="/fiscal">{t('fiscal')}</NavLink>}
                </NavMenu>
              )}
            </NavLeft>
            <NavUser onClick={() => setSidebarOpen(true)}>
              <Image src={DefaultImage} width={36} height={36} style={{ borderRadius: '100%' }} />
              <span to="/user_profiler">{business.title}</span>
            </NavUser>
          </Nav>
        </MacroContainer>
      </Container>
    </>
  );
};